import {
  type FilterTableItemDescriptor,
  generateHeadersAndFilters,
} from "../../../../../Components/FilterTable/filterTableUtils";
import { type OpenAIAssetRowData } from "./OpenAIAssetRow";

const openaiItemDescriptors: FilterTableItemDescriptor<OpenAIAssetRowData>[] = [
  {
    headerText: "Organization ID",
    value: "orgId",
    filterType: "string",
  },
  {
    headerText: "Organization Name",
    value: "orgName",
    filterType: "string",
  },
  {
    headerText: "Status",
    value: "status",
    filterType: "string",
  },
];

const { filters, headerColumns: baseHeaderColumns } = generateHeadersAndFilters(openaiItemDescriptors);
const headerColumns = [...baseHeaderColumns] as const;

export { filters, headerColumns };
